import PointsOfAttention from './PointsOfAttention'

export default PointsOfAttention
